var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.639,
    height: 27.639,
    viewBox: "0 0 27.639 27.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M25.664,27.639H1.974A1.982,1.982,0,0,1,0,25.664V1.974A1.981,1.981,0,0,1,1.974,0h23.69a1.982,1.982,0,0,1,1.976,1.974v23.69A1.983,1.983,0,0,1,25.664,27.639ZM1.974,10.858V25.664H25.667l0-14.806Zm9.872-8.884v6.91H25.664V1.974Zm-9.872,0v6.91h7.9V1.974ZM19.742,23.692H17.768V13.82h1.974v9.872Zm3.948,0H21.716V18.756H23.69v4.936Zm-14.806,0a4.951,4.951,0,0,1-4.936-4.936H5.922a2.961,2.961,0,1,0,2.962-2.962V13.82a4.936,4.936,0,0,1,0,9.872Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.51c7d08b8d289adbb7c38f76f0a979c3.svg";
export { ForwardRef as ReactComponent };